import React, { useMemo, useState, useCallback } from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";
import  "../../styles/main.css";

import TabsBase from "../../components/reusable/Navigation/TabsBase";
import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import ToolbarHeadSubpage from "../../components/framepart/SubpageLayout/ToolbarHeadSubpage";
import DropdownMulti from "../../components/reusable/Forms/DropdownMulti";
import DropdownList from "../../components/reusable/Forms/DropdownList";
import Button from "../../components/reusable/Forms/Button";
import TextFilter from "../../components/reusable/Forms/TextFilter";
import Switch from "../../components/reusable/Forms/Switch";

import BudgetStructureBoard from "../../components/defined/budget_structure/BudgetStructureBoard";
import BudgetStructurePanel from "../../components/defined/budget_structure/BudgetStructurePanel";

import CostStructureBoard from "../../components/defined/budget_cost/CostStructureBoard";
import CostStructurePanel from "../../components/defined/budget_cost/CostStructurePanel";
import CostBanner from "../../components/defined/budget_cost/CostBanner";

import QuantitiesBoard from "../../components/defined/budget_quantities/QuantitiesBoard";
import QuantitiesPanel from "../../components/defined/budget_quantities/QuantitiesPanel";


import CostingBoard from "../../components/defined/budget_costing/CostingBoard";
import CostingPanel from "../../components/defined/budget_costing/CostingPanel";

import JourneyTabs from "../../components/reusable/Navigation/JourneyTabs";


import DatagridSimple from "../../components/reusable/Datagrid/DatagridSimple";
import DatagridCorelia from "../../components/defined/Corelia_standard/CoreliaTable";

/* ============================================================
   OPTIONS GÉNÉRIQUES
============================================================ */
const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];

/* ============================================================
   CONSTANTES TABS
============================================================ */
const TAB_KEYS = {
  PACKAGE: 0,
  COST: 1,
  QUANTITIES: 2,
  COSTING: 3,
  REVIEW: 4,
  REPORT: 5,
};

/* ============================================================
   HELPERS BANNER
============================================================ */
const getInitialFilterForConfig = (config) => {
  if (!config?.showFilters) return "";
  if (!Array.isArray(config?.filterOptions) || config.filterOptions.length === 0) {
    return "";
  }
  return config.filterOptions[0];
};

const sanitizeBannerState = (config, state) => {
  const safeConfig = config || {};
  const safeState = state || {};
  const filterOptions = Array.isArray(safeConfig.filterOptions)
    ? safeConfig.filterOptions
    : [];

  const activeFilter =
    safeConfig.showFilters && filterOptions.includes(safeState.activeFilter)
      ? safeState.activeFilter
      : getInitialFilterForConfig(safeConfig);

  return {
    activeFilter,
  };
};

const mergeBannerConfigWithBoardData = (config, boardData) => {
  const safeConfig = config || {};
  const safeBoardData = boardData || {};

  return {
    ...safeConfig,
    metrics: Array.isArray(safeBoardData.metrics)
      ? safeBoardData.metrics
      : safeConfig.metrics,
    legends: Array.isArray(safeBoardData.legends)
      ? safeBoardData.legends
      : safeConfig.legends,
    filterOptions: Array.isArray(safeBoardData.filterOptions)
      ? safeBoardData.filterOptions
      : safeConfig.filterOptions,
    showMetrics:
      typeof safeBoardData.showMetrics === "boolean"
        ? safeBoardData.showMetrics
        : safeConfig.showMetrics,
    showFilters:
      typeof safeBoardData.showFilters === "boolean"
        ? safeBoardData.showFilters
        : safeConfig.showFilters,
    showLegends:
      typeof safeBoardData.showLegends === "boolean"
        ? safeBoardData.showLegends
        : safeConfig.showLegends,
  };
};

/* ============================================================
   FACTORISATION — Styles communs aux containers
============================================================ */
const baseLeftZoneStyle = {
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  borderRadius: 6,
  boxSizing: "border-box",
};

const baseRightZoneStyle = {
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  padding: 12,
  borderRadius: 6,
  boxSizing: "border-box",
};

/* ============================================================
   WRAPPERS INTERNES DE CONTENU
============================================================ */
const a1ContentStyle = {
  width: "100%",
  minWidth: 0,
  minHeight: "100%",
  height: "auto",
  display: "flex",
  flexDirection: "column",
  overflow: "visible",
  boxSizing: "border-box",
};

const b1ScrollContentStyle = {
  width: "100%",
  minWidth: 0,
  minHeight: "100%",
  height: "auto",
  overflow: "visible",
  boxSizing: "border-box",
  paddingRight: 2,
  paddingBottom: 0,
};

const c1ScrollContentStyle = {
  width: "100%",
  minWidth: 0,
  minHeight: "100%",
  height: "auto",
  overflow: "visible",
  boxSizing: "border-box",
  paddingRight: 2,
  paddingBottom: 0,
};

/* ============================================================
   STRUCTURE GLOBALE DE PAGE
============================================================ */
const pageRootStyle = {
  padding: 0,
  margin: 0,
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
};

/* ============================================================
   WRAPPERS TAB
============================================================ */
const tabStyle = {
  display: "flex",
  flexDirection: "row",
  gap: 0,
  padding: 0,
  margin: 0,
  overflow: "hidden",
  minWidth: 0,
  minHeight: 0,
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  alignItems: "stretch",
};

const tabInnerStyle = {
  display: "flex",
  flexDirection: "row",
  gap: 10,
  padding: "6px 10px 2px 10px",
  margin: 0,
  overflow: "hidden",
  minWidth: 0,
  minHeight: 0,
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  alignItems: "stretch",
};

/* ============================================================
   COLONNES 75 / 25
============================================================ */
const leftColumnShellStyle = {
  flex: "0 0 75%",
  width: "75%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
};

const rightColumnShellStyle = {
  flex: "0 0 25%",
  width: "25%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
};

/* ============================================================
   STACK GAUCHE — BANNER + BODY
============================================================ */
const leftStackStyle = {
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxSizing: "border-box",
};

const bannerStyle = {
  flex: "0 0 13%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  boxSizing: "border-box",
  display: "flex",
  alignItems: "stretch",
};

const bannerInnerStyle = {
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  boxSizing: "border-box",
};

/* ============================================================
   VIEWPORTS DE SCROLL
============================================================ */
const leftBodyViewportStyle = {
  flex: "1 1 auto",
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  boxSizing: "border-box",
};

const rightColumnViewportStyle = {
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  boxSizing: "border-box",
};

/* ============================================================
   CONTENEUR BANNER
============================================================ */
const bannerContentStyle = {
  width: "100%",
  height: "100%",
  minWidth: 0,
  minHeight: 0,
  borderRadius: 6,
  boxSizing: "border-box",
  overflow: "hidden",
  background: "transparent",
  padding: "2px 0",
};

/* ============================================================
   ADAPTATION DE CONTAINERBASE À UNE COLONNE SCROLLABLE
============================================================ */
const getColumnZoneStyle = (zoneStyle = {}) => ({
  ...zoneStyle,
  width: "100%",
  height: "auto",
  minWidth: 0,
  minHeight: 0,
  overflow: "visible",
  boxSizing: "border-box",
});

/* ============================================================
   COMPOSANT DE LAYOUT COMMUN
============================================================ */
const SplitTabLayout = ({ leftZone, rightZone, bannerProps }) => {
  return (
    <div style={tabStyle}>
      <div style={tabInnerStyle}>
        <div style={leftColumnShellStyle}>
          <div style={leftStackStyle}>
            <div style={bannerStyle}>
              <div style={bannerInnerStyle}>
                <div style={bannerContentStyle}>
                  <CostBanner {...bannerProps} />
                </div>
              </div>
            </div>

            <div style={leftBodyViewportStyle}>
              <ContainerBase
                {...leftZone}
                style={getColumnZoneStyle(leftZone?.style)}
              />
            </div>
          </div>
        </div>

        <div style={rightColumnShellStyle}>
          <div style={rightColumnViewportStyle}>
            <ContainerBase
              {...rightZone}
              style={getColumnZoneStyle(rightZone?.style)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/* ============================================================
   PAGE
============================================================ */
const Subpage_107 = () => {
  // États internes
  const [searchTerm, setSearchTerm] = useState("");  // Pour la recherche (si nécessaire)
  const [switchOn, setSwitchOn] = useState(false);  // Pour un switch (si nécessaire)
  const [activeTab, setActiveTab] = useState(TAB_KEYS.PACKAGE);  // Gérer les onglets
  const [selectedCategories, setSelectedCategories] = useState([]);  // Catégories sélectionnées (si nécessaire)
  
  // État de sélection des lignes
  const [selectedRows, setSelectedRows] = useState([]);  // Liste des lignes sélectionnées

  // Fonction de gestion de la sélection/désélection des lignes
  const [selectedId, setSelectedId] = useState(null);

// Fonction de gestion de la sélection / désélection de ligne
const handleSelectionChange = (selectedId, selectedRow) => {
  setSelectedId(selectedId); // Met à jour l'ID de la ligne sélectionnée
  setSelectedRows((prevSelected) => {
    if (prevSelected.includes(selectedId)) {
      // Si la ligne est déjà sélectionnée, la retirer de la liste
      return prevSelected.filter((id) => id !== selectedId);
    } else {
      // Si la ligne n'est pas sélectionnée, l'ajouter à la liste
      return [...prevSelected, selectedId];
    }
  });
};
  /* ============================================================
     CONFIGURATION DÉCLARATIVE DU BANNER PAR ONGLET
  ============================================================ */
  const bannerConfigByTab = useMemo(
    () => ({
      [TAB_KEYS.PACKAGE]: {
        overline: "Package structure",
        title: "Organisation des packages budgétaires",
        metrics: [
          {
            label: "Packages",
            value: 12,
            valueColor: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Structured",
            value: 8,
          },
          {
            label: "Coverage",
            value: "Initial",
            valueColor: theme?.colors?.text?.caneva || "#c24c2c",
          },
        ],
        filterOptions: ["Structure", "Coverage", "Readiness"],
        legends: [
          {
            label: "Structured",
            color: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Ready",
            color: theme?.colors?.text?.green || "#1A8C74",
          },
          {
            label: "To complete",
            color: "#B8621B",
          },
        ],
        showMetrics: true,
        showFilters: true,
        showLegends: true,
      },

      [TAB_KEYS.COST]: {
        overline: "Cost structure",
        title: "Matching des sous-éléments avec le catalogue de coûts Corelia",
        metrics: [
          {
            label: "Matched articles",
            value: 2,
            valueColor: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Catalog results",
            value: 8,
          },
          {
            label: "Coverage",
            value: "Partial",
            valueColor: theme?.colors?.text?.caneva || "#c24c2c",
          },
        ],
        filterOptions: ["Matching", "Coverage", "Catalog"],
        legends: [
          {
            label: "Matched",
            color: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Ready",
            color: theme?.colors?.text?.green || "#1A8C74",
          },
          {
            label: "To complete",
            color: "#B8621B",
          },
        ],
        showMetrics: true,
        showFilters: true,
        showLegends: true,
      },

      [TAB_KEYS.QUANTITIES]: {
        overline: "Quantities",
        title: "Consolidation des quantités et logique empirique de quantification",
        metrics: [
          {
            label: "Lines",
            value: 0,
            valueColor: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Defined",
            value: 0,
          },
          {
            label: "Rule-based",
            value: 0,
            valueColor: theme?.colors?.text?.caneva || "#c24c2c",
          },
        ],
        filterOptions: ["Quantities", "Drivers", "Rules"],
        legends: [
          {
            label: "Manual",
            color: theme?.colors?.text?.corelia || "#0e3f56",
          },
          {
            label: "Inherited",
            color: theme?.colors?.text?.green || "#1A8C74",
          },
          {
            label: "Rule",
            color: theme?.colors?.text?.caneva || "#c24c2c",
          },
        ],
        showMetrics: true,
        showFilters: true,
        showLegends: true,
      },

      [TAB_KEYS.COSTING]: {
        overline: "Costing",
        title: "Construction du chiffrage et bases d’évaluation",
        metrics: [{ label: "Items", value: 0 }],
        filterOptions: ["Costing"],
        legends: [],
        showMetrics: true,
        showFilters: true,
        showLegends: false,
      },

      [TAB_KEYS.REVIEW]: {
        overline: "Review",
        title: "Contrôle et revue de la structure budgétaire",
        metrics: [{ label: "Open points", value: 0 }],
        filterOptions: ["Review"],
        legends: [],
        showMetrics: true,
        showFilters: true,
        showLegends: false,
      },

      [TAB_KEYS.REPORT]: {
        overline: "Report",
        title: "Préparation des livrables et synthèses",
        metrics: [{ label: "Reports", value: 0 }],
        filterOptions: ["Report"],
        legends: [],
        showMetrics: true,
        showFilters: true,
        showLegends: false,
      },
    }),
    []
  );
  
  /* ============================================================
     DATAGRID CONSTANTE
  ============================================================ */
  const elementsColumns = [
    { header: "ID", accessor: "id", width: "100px" },
    { header: "Nom", accessor: "name", width: "150px" },
    { header: "Type", accessor: "type", width: "150px" },
    { header: "Phase", accessor: "phase", width: "150px" },
    
  ];

  const elementsData = [
    { id: "E-001", name: "Mur porteur RDC", type: "", phase: "Gros-Œuvre" },
    { id: "E-002", name: "Fenêtre bureau", type: "", phase: "Menuiserie" },
    { id: "E-003", name: "Porte coupe-feu", type: "Door", phase: "" },
  ];

// Liste des colonnes à mettre en gras
  const boldColumns = ["ID"]; // Colonnes en gras

  // Liste des colonnes à rendre éditables
const editableColumns = ["type", "phase"]; // Par exemple, "name" et "phase" seront éditables
  /* ============================================================
     ÉTAT INTERACTIF DU BANNER PAR ONGLET
  ============================================================ */
  const [bannerStateByTab, setBannerStateByTab] = useState(() => {
    const initialState = {};

    Object.keys(bannerConfigByTab).forEach((tabKey) => {
      initialState[tabKey] = {
        activeFilter: getInitialFilterForConfig(bannerConfigByTab[tabKey]),
      };
    });

    return initialState;
  });

  /* ============================================================
     DONNÉES REMONTÉES PAR LES BOARDS PAR ONGLET
  ============================================================ */
  const [boardBannerDataByTab, setBoardBannerDataByTab] = useState({});

  /* ============================================================
     HANDLERS GÉNÉRIQUES
  ============================================================ */
  const updateBannerStateForTab = useCallback((tabKey, patch) => {
    setBannerStateByTab((prev) => ({
      ...prev,
      [tabKey]: {
        ...(prev?.[tabKey] || {}),
        ...patch,
      },
    }));
  }, []);

  const updateBoardBannerDataForTab = useCallback((tabKey, patch) => {
    setBoardBannerDataByTab((prev) => ({
      ...prev,
      [tabKey]: {
        ...(prev?.[tabKey] || {}),
        ...patch,
      },
    }));
  }, []);

  /* ============================================================
     RÉSOLUTION COMPLÈTE DU BANNER POUR UN ONGLET
  ============================================================ */
  const getResolvedBannerProps = useCallback(
    (tabKey) => {
      const baseConfig = bannerConfigByTab[tabKey] || {
        overline: "Budget",
        title: "Budget workspace",
        metrics: [],
        filterOptions: [],
        legends: [],
        showMetrics: false,
        showFilters: false,
        showLegends: false,
      };

      const boardData = boardBannerDataByTab[tabKey] || {};
      const mergedConfig = mergeBannerConfigWithBoardData(baseConfig, boardData);
      const resolvedState = sanitizeBannerState(
        mergedConfig,
        bannerStateByTab[tabKey]
      );

      return {
        ...mergedConfig,
        activeFilter: resolvedState.activeFilter,
        onFilterChange: (value) => {
          updateBannerStateForTab(tabKey, { activeFilter: value });
        },
      };
    },
    [bannerConfigByTab, boardBannerDataByTab, bannerStateByTab, updateBannerStateForTab]
  );

  /* ============================================================
     RÉSOLUTION COMPLÈTE DES PROPS BOARD POUR UN ONGLET
  ============================================================ */
  const getResolvedBoardProps = useCallback(
    (tabKey) => {
      const resolvedBannerProps = getResolvedBannerProps(tabKey);

      return {
        activeFilter: resolvedBannerProps.activeFilter,
        onBannerDataChange: (data) => {
          updateBoardBannerDataForTab(tabKey, data);
        },
      };
    },
    [getResolvedBannerProps, updateBoardBannerDataForTab]
  );

  /* ============================================================
     ZONE A1 — PACKAGE CONNECTÉE AU BANNER
  ============================================================ */
  const zoneA1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    sections: [
      {
        title: "",
        content: (
          <div style={a1ContentStyle}>
            <BudgetStructureBoard {...getResolvedBoardProps(TAB_KEYS.PACKAGE)} />
          </div>
        ),
      },
    ],
  };

  /* ============================================================
     ZONE A2
  ============================================================ */
  const zoneA2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <BudgetStructurePanel />,
      },
    ],
  };

  /* ============================================================
     ZONE B1 — COST CONNECTÉE AU BANNER
  ============================================================ */
  const zoneB1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
      gap: 8,
      sectionGap: 4,
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    sections: [
      {
        title: "",
        content: (
          <div style={b1ScrollContentStyle}>
            <CostStructureBoard {...getResolvedBoardProps(TAB_KEYS.COST)} />
          </div>
        ),
      },
    ],
  };

  /* ============================================================
     ZONE B2
  ============================================================ */
  const zoneB2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <CostStructurePanel />,
      },
    ],
  };

  /* ============================================================
     ZONE C1 — QUANTITIES CONNECTÉE AU BANNER
  ============================================================ */
  const zoneC1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    sections: [
      {
        title: "",
        content: (
          <div style={c1ScrollContentStyle}>
            <QuantitiesBoard {...getResolvedBoardProps(TAB_KEYS.QUANTITIES)} />
          </div>
        ),
      },
    ],
  };

  /* ============================================================
     ZONE C2
  ============================================================ */
  const zoneC2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <QuantitiesPanel />,
      },
    ],
  };

  /* ============================================================
     ZONES FUTURES
  ============================================================ */
  const zoneD1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    
    sections: [
      {
        title: "",
        content: (
          <div >
            <DatagridCorelia  columns={elementsColumns} data={elementsData} boldColumns={boldColumns} 
            selectable={true} onSelectionChange={handleSelectionChange} selectedRows={selectedRows} 
            editableColumns={editableColumns} borderEnabled={false} />
          </div>
          
        ),
      },
    ],
  };

  const zoneD2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <div >
            <CostingBoard  />


            
          
            
          

          </div>
        ),
      },
    ],
  };
  const zoneE1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    sections: [{ title: "", content: <div></div> }],
  };

  const zoneE2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [{ title: "", content: <div></div> }],
  };

  const zoneF1 = {
    style: {
      ...baseLeftZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 16,
    sectionGap: 6,
    contentPadding: 0,
    sections: [{ title: "", content: <div></div> }],
  };

  const zoneF2 = {
    style: {
      ...baseRightZoneStyle,
      display: "flex",
      flexDirection: "column",
    },
    gap: 12,
    sectionGap: 6,
    sections: [{ title: "", content: <div></div> }],
  };

  /* ============================================================
     TABS
  ============================================================ */
  const TabA = (
    <SplitTabLayout
      leftZone={zoneA1}
      rightZone={zoneA2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.PACKAGE)}
    />
  );

  const TabB = (
    <SplitTabLayout
      leftZone={zoneB1}
      rightZone={zoneB2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.COST)}
    />
  );

  const TabC = (
    <SplitTabLayout
      leftZone={zoneC1}
      rightZone={zoneC2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.QUANTITIES)}
    />
  );

  const TabD = (
    <SplitTabLayout
      leftZone={zoneD1}
      rightZone={zoneD2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.COSTING)}
    />
  );

  const TabE = (
    <SplitTabLayout
      leftZone={zoneE1}
      rightZone={zoneE2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.REVIEW)}
    />
  );

  const TabF = (
    <SplitTabLayout
      leftZone={zoneF1}
      rightZone={zoneF2}
      bannerProps={getResolvedBannerProps(TAB_KEYS.REPORT)}
    />
  );

  const tabs = [
    { label: "Package Structure", content: TabA },
    { label: "Cost Structure", content: TabB },
    { label: "Quantities", content: TabC },
    { label: "Costing", content: TabD },
    { label: "Review", content: TabE },
    { label: "Report", content: TabF },
  ];

  /* ============================================================
     RENDER
  ============================================================ */
  return (
    
    <div style={pageRootStyle}>
      <JourneyTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        componentWidth="60%"
        stepsWidth="100%"
        componentOffsetLeft={0}
        headerPaddingLeft={24}
        tabsDisabled={false}
        containerStyle={{
          width: "100%",
          height: "100%",
          minHeight: 0,
          minWidth: 0,
          margin: 0,
          padding: 0,
          overflow: "hidden",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      />
    </div>
  );
};

export default Subpage_107;